import React from 'react';
import moment from 'moment';
import { PropTypes } from 'prop-types';

// import { MdMoreVert } from 'react-icons/md';


function ScanListItem(props) {

    const { scan } = props;

    return (
        <div className="row ScanListItem DataListItem align-items-center">
            <div className="col-md-1 align-middle">
                <span>{moment(scan.timeScanned).format('H:mm:ss')}</span><br />
                <span style={{color: "#999"}}>{moment(scan.timeScanned).format('DD/MM/YY')}</span>
            </div>
            <div className="col-md-3 align-middle">
                <span style={{fontWeight: 'bold'}}>{scan.firstNames} {scan.lastName}</span>
                {scan.email ?
                    <React.Fragment>
                        <br />
                        <span>{scan.email}</span>
                    </React.Fragment>
                : null}
            </div>
            <div className="col-md-2 align-middle">
                <span style={{ fontWeight: 'bold' }}>{scan.company}</span>
            </div>
            <div className="col-md-2 align-middle">

                <span>{scan.jobTitle}</span>
            </div>
            <div className="col-md-4 align-middle">
                {scan.comment &&
                    <div className="speech-bubble"><span>{scan.comment}</span></div>
                }
            </div>
            {/*<div className="col-1 text-right">
                <MdMoreVert />
            </div>*/}
        </div>
    )
}

ScanListItem.propTypes = {
    scan: PropTypes.object
}

export default ScanListItem;